document.addEventListener('DOMContentLoaded', function () {

    // Desktop Filer & Sort Cod
    let filterButton = document.querySelector('[data-filter-button]');
    let filterGroup = document.querySelector('#filter-group-display');
    let sortButton = document.querySelector('[data-sort_by-button]');
    let sortGroup = document.querySelector('#sort_by-group-display');
  
    filterButton.addEventListener('click', function () {
      this.classList.toggle('active');
      filterGroup.classList.toggle('active');
    });
  
    sortButton.addEventListener('click', function () {
      this.classList.toggle('active');
      sortGroup.classList.toggle('active');
    });
  
    document.addEventListener('click', function (event) {
      // Filter Modal
      if (!filterGroup.contains(event.target) && !filterButton.contains(event.target)) {
        filterButton.classList.remove('active');
        filterGroup.classList.remove('active');
      }
  
      // Sort Modal
      if (!sortGroup.contains(event.target) && !sortButton.contains(event.target)) {
        sortButton.classList.remove('active');
        sortGroup.classList.remove('active');
      }
    });
    const loadMoreProducts = async () => {
      const loadMoreBtn = document.querySelector(".load-more a");
      if (!loadMoreBtn) return;
  
      try {
          const urlParams = new URLSearchParams(window.location.search);
          const currCollection = window.location.pathname;
          let currPage = parseInt(new URL(loadMoreBtn.href).searchParams.get("page"), 10) || 1;
          const pagesTotal = parseInt(loadMoreBtn.id, 10);
          const productGrid = document.querySelector('ul#product-grid');
  
          if (!productGrid) return;
  
          loadMoreBtn.innerHTML = 'Loading...';
  
          // Function to load pages one by one and append them in the correct order
          const loadPage = async (page) => {
              if (page > pagesTotal) {
                  loadMoreBtn.remove(); // Remove button when all pages are loaded
                  return;
              }
  
              urlParams.set("page", page);
              const pageUrl = `${currCollection}?${urlParams.toString()}`;
  
              try {
                  const response = await fetch(pageUrl, { method: 'GET', credentials: 'include' });
                  const resText = await response.text();
                  const parser = new DOMParser();
                  const doc = parser.parseFromString(resText, "text/html");
                  const newProducts = doc.querySelector('ul#product-grid');
  
                  const appendUniqueProducts = (productGrid, newProducts) => {
                      const existingIds = new Set(
                        [...productGrid.querySelectorAll('.product-grid-item')]
                          .map(item => item.dataset.itemId)
                          .filter(Boolean)
                      );
                      console.log('Existing product IDs:', existingIds.size);

                      const newItems = [...newProducts.querySelectorAll('.product-grid-item')];

                      newItems.forEach(item => {
                        const id = item.dataset.itemId;
                        if (!id || existingIds.has(id)) return; // skip duplicates

                        existingIds.add(id);
                      console.log('Existing product IDs:', existingIds.size);

                        productGrid.appendChild(item);
                      });
                    };


                    // if (newProducts) {
                    //     productGrid.insertAdjacentHTML('beforeend', newProducts.innerHTML);
                    // }
                    if (newProducts) {
                      console.log('Appending products from page ', page);
                      appendUniqueProducts(productGrid, newProducts);
                    }
  
                  // Update filters dynamically
                  updateFilters();
  
                  // Update "View Results" text
                  updateViewResults();
  
                  // Load the next page after appending the current one
                  await loadPage(page + 1);
  
              } catch (error) {
                  console.error(`Error loading page ${page}:`, error);
                  // Continue loading the next page even if this one fails
                  await loadPage(page + 1);
              }
          };
  
          // Start loading pages from the next page
          await loadPage(currPage);
  
          // Remove loading state after all pages are loaded
          setTimeout(() => {
              document.getElementById("ProductGridContainer")?.classList.remove('loading');
          }, window.location.search ? 7000 : 3000);
  
      } catch (error) {
          console.error("Error loading more products:", error);
          loadMoreBtn.innerHTML = 'View More'; // Reset button text in case of failure
      }
  };
  
  // Sync the "X Results" count in the search header with the latest fetched HTML
  const updateResultsCount = (html) => {
    const newCount = html.querySelector('.search-header-info li');
    const currentCount = document.querySelector('.search-header-info li');
    if (newCount && currentCount) {
      currentCount.textContent = newCount.textContent;
    }
  };

  // Function to update filters dynamically
  const updateFilters = () => {
      const allNewProducts = document.querySelectorAll('.product-grid-item:not(.hidden)');
      const filterColorList = document.querySelector('.filter-color-list');
  
      if (!filterColorList) return;
  
      allNewProducts.forEach((product) => {
          const dataFilter = product.getAttribute('data-filter')?.toLowerCase()
              .replace(/[^\w\u00C0-\u024f]+/g, "-")
              .replace(/^-+|-+$/g, "");
  
          if (!dataFilter) return;
  
          const filterExists = [...document.querySelectorAll('.filter-color-list .mobile-facets__checkbox')]
              .some(filter => filter.value === dataFilter);
  
          if (!filterExists) {
              filterColorList.insertAdjacentHTML('beforeend', `
                  <li class="mobile-facets__item list-menu__item typography-text uppercase mobile-facet-${dataFilter}">
                      <label for="Filter--color-mobile-${filterColorList.children.length + 1}" class="mobile-facets__label">
                          <input type="checkbox" name="color" class="mobile-facets__checkbox" 
                                 value="${dataFilter}" data-attr="${dataFilter}" 
                                 id="Filter--color-mobile-${filterColorList.children.length + 1}">
                          <span class="color-swatch" data-swatch-color="${dataFilter}"></span>
                          <span class="filter-label">${product.getAttribute('data-filter')}</span>
                      </label>
                  </li>
              `);
          }
      });
  };
  
  
    let clpLayoutControls = (gridLayout) => {
      // Switch CLP layout between 2 and 4 grid
      var switchLayoutBtn = document.getElementById('switch-layout');
      var clpGrid = document.querySelector('.clp-grid');
    
      // Check sessionStorage for saved layout
      const savedLayout = sessionStorage.getItem('gridLayout');
      if (savedLayout === 'twoColumnLayout') {
        clpGrid.classList.add('grid-layout');
        switchLayoutBtn.classList.remove('grid-4');
      } else if (savedLayout === 'fourColumnLayout') {
        clpGrid.classList.remove('grid-layout');
        switchLayoutBtn.classList.add('grid-4');
      }
      switchLayoutBtn.setAttribute('aria-label', switchLayoutBtn.classList.contains('grid-4') ? 'Switch to 2-column grid' : 'Switch to 4-column grid');

      $(switchLayoutBtn)
        .unbind()
        .click(function () {
          if (clpGrid.classList.contains('grid-layout')) {
            $(clpGrid).removeClass('grid-layout');
            switchLayoutBtn.classList.add('grid-4');
            // Save layout preference to sessionStorage
            sessionStorage.setItem('gridLayout', 'fourColumnLayout');
          } else {
            $(clpGrid).addClass('grid-layout');
            switchLayoutBtn.classList.remove('grid-4');
            // Save layout preference to sessionStorage
            sessionStorage.setItem('gridLayout', 'twoColumnLayout');
          }

          var isFourColumn = switchLayoutBtn.classList.contains('grid-4');
          switchLayoutBtn.setAttribute('aria-label', isFourColumn ? 'Switch to 2-column grid' : 'Switch to 4-column grid');
          var gridLayoutStatus = document.getElementById('grid-layout-status');
          if (gridLayoutStatus) gridLayoutStatus.textContent = 'Product grid changed to ' + (isFourColumn ? '4' : '2') + ' columns';
        });
    };
    
    function attachFormListener() {
      let form = document.forms.filters;
      let getSearchURL = document.querySelector('[data-search-url]').value;
  
      // Function to handle updates
      function handleUpdate(additionalParams = {}) {
        let data = new FormData(form);
        let params = new URLSearchParams(data);
  
        // Retain the current sort_by parameter from the URL if it's not included in additionalParams
        if (additionalParams.sort_by) {
          params.set('sort_by', additionalParams.sort_by);
        } else {
          let currentParams = new URLSearchParams(window.location.search);
          if (currentParams.has('sort_by')) {
            params.set('sort_by', currentParams.get('sort_by'));
          }
        }
  
        let queryString = params.toString();
  
        fetch(window.location.pathname + getSearchURL + '&' + queryString)
          .then((response) => response.text())
          .then((text) => {
            let html = document.createElement('div');
            html.innerHTML = text;
  
            
            let products = html.querySelector('#ProductGridContainer');
  
            console.log('products', products);
  
            let filter = html.querySelector('#filter-group-display');
            let sort = html.querySelector('#sort_by-group-display');
  
            if (filter && filter.innerHTML.trim().length) {
              document.querySelector('#filter-group-display').innerHTML = filter.innerHTML;
            }
  
            if (sort && sort.innerHTML.trim().length) {
              document.querySelector('#sort_by-group-display').innerHTML = sort.innerHTML;
            }
  
            if (products && products.innerHTML.trim().length) {
              document.querySelector('#ProductGridContainer').innerHTML = products.innerHTML;
            }

            updateResultsCount(html);

            let count = html.querySelectorAll('[data-active-filter]').length;
            let activeFilterCount = document.querySelector('[data-active-filter-count]');
            if (activeFilterCount) {
              activeFilterCount.textContent = count ? `(${count})` : '';
            }

            // Reattach the event listeners after the HTML is updated
            attachFormListener();
            // Update the URL without reloading the page
            window.history.pushState(null, null, window.location.pathname + getSearchURL + '&' + queryString);
            loadMoreProducts();
          })
          .catch((e) => {
            console.error(e);
          });
      }
  
      // Availability Apply/Reset buttons stay disabled until a filter is selected
      function enableAvailabilityButtonsDesktop() {
        let applyBtn = document.getElementById('AvailabilityApplyDesktop');
        let resetBtn = document.getElementById('AvailabilityResetDesktop');
        if (applyBtn) applyBtn.disabled = false;
        if (resetBtn) resetBtn.disabled = false;
      }

      // Listener for filters
      form.addEventListener('input', function () {
        enableAvailabilityButtonsDesktop();
        handleUpdate();
      });

      // Listener for sort options
      let sortOptions = document.querySelectorAll('.sortby-input');
      sortOptions.forEach((option) => {
        option.addEventListener('change', function () {
          handleUpdate({ sort_by: this.value });
        });
      });

      let savedLayout = sessionStorage.getItem('gridLayout') || 'fourColumnLayout';
      clpLayoutControls(savedLayout);

      let filterCloseBtn = document.querySelector('.filter-group-display__form-header .close-filter-icon');
      filterCloseBtn.addEventListener('click', function () {
        filterButton.classList.remove('active');
        filterGroup.classList.remove('active');
      });
    }
  
    let count = document.querySelectorAll('[data-active-filter]').length;
    let activeFilterCount = document.querySelector('[data-active-filter-count]');
    if (activeFilterCount) {
      activeFilterCount.textContent = count ? `(${count})` : '';
    }
  
    window.close_facets = function () {
      filterButton.classList.remove('active');
      filterGroup.classList.remove('active');
    };
  
    window.remove_facets = function (url) {
      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          let html = document.createElement('div');
          html.innerHTML = text;
  
          let products = html.querySelector('#ProductGridContainer');
          let filter = html.querySelector('#filter-group-display');
  
          if (filter && filter.innerHTML.trim().length) {
            document.querySelector('#filter-group-display').innerHTML = filter.innerHTML;
          }
  
          if (products && products.innerHTML.trim().length) {
            document.querySelector('#ProductGridContainer').innerHTML = products.innerHTML;
          }

          updateResultsCount(html);

          let count = html.querySelectorAll('[data-active-filter]').length;
          let activeFilterCount = document.querySelector('[data-active-filter-count]');
          if (activeFilterCount) {
            activeFilterCount.textContent = count ? `(${count})` : '';
          }

          // Reattach the event listener after the HTML is updated
          attachFormListener();
          // New URL you want to set
          let newUrl = url;
          
          // Update the URL without reloading the page
          window.history.pushState(null, null, newUrl);
          loadMoreProducts();
        })
        .catch((e) => {
          console.error(e);
        });
    };
  
    // Initial call to set up the event listener
    attachFormListener();
  
  
    // <--------------------------/////////------------------------------>
  
  
    // Mobile Filer & Sort Code
    let filterButtonMobile = document.querySelector('[data-filter-button-mobile]');
    let filterGroupMobile = document.querySelector('#filter-group-display-mobile');
    let sortButtonMobile = document.querySelector('[data-sort_by-button-mobile]');
    let sortGroupMobile = document.querySelector('#sort_by-group-display-mobile');
  
    filterButtonMobile.addEventListener('click', function () {
      this.classList.toggle('active');
      filterGroupMobile.classList.toggle('active');
    });
  
    sortButtonMobile.addEventListener('click', function () {
      this.classList.toggle('active');
      sortGroupMobile.classList.toggle('active');
    });
  
    document.addEventListener('click', function (event) {
      // Filter Modal
      if (!filterGroupMobile.contains(event.target) && !filterButtonMobile.contains(event.target)) {
        filterButtonMobile.classList.remove('active');
        filterGroupMobile.classList.remove('active');
      }
  
      // Sort Modal
      if (!sortGroupMobile.contains(event.target) && !sortButtonMobile.contains(event.target)) {
        sortButtonMobile.classList.remove('active');
        sortGroupMobile.classList.remove('active');
      }
    });
  
    function attachFormListenerMobile() {
      let form = document.forms.filtersMobile;
      let getSearchURL = document.querySelector('[data-search-url]').value;

      // Function to handle updates
      function handleUpdate(additionalParams = {}) {
        let data = new FormData(form);
        let params = new URLSearchParams(data);
  
        if (additionalParams.sort_by) {
          params.set('sort_by', additionalParams.sort_by);
        } else {
          let currentParams = new URLSearchParams(window.location.search);
          if (currentParams.has('sort_by')) {
            params.set('sort_by', currentParams.get('sort_by'));
          }
        }
  
        let queryString = params.toString();
  
        fetch(window.location.pathname + getSearchURL + '&' + queryString)
          .then((response) => response.text())
          .then((text) => {
            let html = document.createElement('div');
            html.innerHTML = text;
  
            let products = html.querySelector('#ProductGridContainer');
            let filter = html.querySelector('#filter-group-display-mobile');
            let sort = html.querySelector('#sort_by-group-display-mobile');
  
            if (filter && filter.innerHTML.trim().length) {
              document.querySelector('#filter-group-display-mobile').innerHTML = filter.innerHTML;
            }
  
            if (sort && sort.innerHTML.trim().length) {
              document.querySelector('#sort_by-group-display-mobile').innerHTML = sort.innerHTML;
            }
  
            if (products && products.innerHTML.trim().length) {
              document.querySelector('#ProductGridContainer').innerHTML = products.innerHTML;
            }

            updateResultsCount(html);

            let countMobile = html.querySelectorAll('[data-active-filter-mobile]').length;
            let activeFilterCountMobile = document.querySelector('[data-active-filter-count-mobile]');
            if (activeFilterCountMobile) {
              activeFilterCountMobile.textContent = countMobile ? `(${countMobile})` : '';
            }

            // Reattach the event listeners after the HTML is updated
            attachFormListenerMobile();
            // Update the URL without reloading the page
            window.history.pushState(null, null, window.location.pathname + getSearchURL + '&' + queryString);
            loadMoreProducts(); 
          })
          .catch((e) => {
            console.error(e);
          });
      }
  
      // Availability Apply/Reset buttons stay disabled until a filter is selected
      function enableAvailabilityButtonsMobile() {
        let applyBtn = document.getElementById('AvailabilityApplyMobile');
        let resetBtn = document.getElementById('AvailabilityResetMobile');
        if (applyBtn) applyBtn.disabled = false;
        if (resetBtn) resetBtn.disabled = false;
      }

      // Listener for filters
      form.addEventListener('input', function () {
        enableAvailabilityButtonsMobile();
        handleUpdate();
      });

      // Listener for sort options
      let sortOptions = document.querySelectorAll('.sortby-input-mobile');
      sortOptions.forEach((option) => {
        option.addEventListener('change', function () {
          handleUpdate({ sort_by: this.value });
        });
      });

      let countMobile = document.querySelectorAll('[data-active-filter-mobile]').length;
      let activeFilterCountMobile = document.querySelector('[data-active-filter-count-mobile]');
      if (activeFilterCountMobile) {
        activeFilterCountMobile.textContent = countMobile ? `(${countMobile})` : '';
      }
  
      let mobileFilterShowButton = document.querySelectorAll('[data-header-filter-group-label]');
  
      // Check session storage for the active filter and set it initially
      let savedFilter = sessionStorage.getItem('activeFilter');
      if (savedFilter) {
        // Add the 'active' class to the saved button
        mobileFilterShowButton.forEach((button) => {
          if (button.getAttribute('data-header-filter-group-label') === savedFilter) {
            button.classList.add('active');
          } else {
            button.classList.remove('active');
          }
        });
  
        // Show the corresponding filter group
        let filterGroup = document.querySelectorAll('[data-body-filter-group-label]');
        filterGroup.forEach((group) => {
          if (group.getAttribute('data-body-filter-group-label') === savedFilter) {
            group.classList.add('active');
            group.classList.remove('hidden');
          } else if (group.getAttribute('data-body-filter-group-label') !== 'availability') {
            group.classList.add('hidden');
            group.classList.remove('active');
          }
        });
      }
  
      mobileFilterShowButton.forEach((button) => {
        button.addEventListener('click', function () {
          // Remove 'active' class from all sibling elements
          mobileFilterShowButton.forEach((btn) => btn.classList.remove('active'));
  
          // Add 'active' class to the clicked button
          this.classList.add('active');
  
          let filterLabelValue = this.getAttribute('data-header-filter-group-label');
          // Save the active filter to session storage
          sessionStorage.setItem('activeFilter', filterLabelValue);
  
          let filterGroup = document.querySelectorAll('[data-body-filter-group-label]');
          filterGroup.forEach((group) => {
            if (group.getAttribute('data-body-filter-group-label') === filterLabelValue) {
              group.classList.add('active');
              group.classList.remove('hidden');
            } else if (group.getAttribute('data-body-filter-group-label') !== 'availability') {
              group.classList.add('hidden');
              group.classList.remove('active');
            }
          });
        });
      });
  
      let savedLayout = sessionStorage.getItem('gridLayout') || 'fourColumnLayout';
      clpLayoutControls(savedLayout);
    }

    window.close_facets_mobile = function () {
      filterButtonMobile.classList.remove('active');
      filterGroupMobile.classList.remove('active');
    };
  
    window.remove_facets_mobile = function (url) {
      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          let html = document.createElement('div');
          html.innerHTML = text;
  
          let products = html.querySelector('#ProductGridContainer');
          let filter = html.querySelector('#filter-group-display-mobile');
  
          if (filter && filter.innerHTML.trim().length) {
            document.querySelector('#filter-group-display-mobile').innerHTML = filter.innerHTML;
          }
  
          if (products && products.innerHTML.trim().length) {
            document.querySelector('#ProductGridContainer').innerHTML = products.innerHTML;
          }

          updateResultsCount(html);

          let countMobile = document.querySelectorAll('[data-active-filter-mobile]').length;
          let activeFilterCountMobile = document.querySelector('[data-active-filter-count-mobile]');
          if (activeFilterCountMobile) {
            activeFilterCountMobile.textContent = countMobile ? `(${countMobile})` : '';
          }

          // Reattach the event listener after the HTML is updated
          attachFormListenerMobile();
          // New URL you want to set
          let newUrl = url;
          
          // Update the URL without reloading the page
          window.history.pushState(null, null, newUrl);
          loadMoreProducts();
        })
        .catch((e) => {
          console.error(e);
        });
    };
  
    // Initial call to set up the event listener
    attachFormListenerMobile();
  
  });